// extracted by mini-css-extract-plugin
export default {"pageContainer":"Home_pageContainer__IzRRM","mainContent":"Home_mainContent__h8HD3"};